import * as tslib_1 from "tslib";
import { FieldType } from '@ngx-formly/core';
var FormlyFieldRecipientChooserComponent = /** @class */ (function (_super) {
    tslib_1.__extends(FormlyFieldRecipientChooserComponent, _super);
    function FormlyFieldRecipientChooserComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return FormlyFieldRecipientChooserComponent;
}(FieldType));
export { FormlyFieldRecipientChooserComponent };
